import onboardingImageStyles from './onboardingImage.module.scss';

export default function SignUpImage(props) {
  return (
    <div className={onboardingImageStyles['signup-image-container']}>
      <img src={`/${props.image}`} alt={props.alt} />
    </div>
  );
}
